<template>
  <div class="content">
    <el-input
      clearable
      style="width: 300px; margin-bottom: 20px;"
      placeholder="手机号检索"
      v-model="mobile"
    >
      <el-button slot="append" @click="getdata">搜索</el-button>
    </el-input>
    <el-table
      :data="cashConfirmData"
      border
      v-loading="cashLoading"
      element-loading-text="正在查询..."
    >
      <el-table-column
        label="消费单号"
        prop="ordersn"
        align="center"
      ></el-table-column>
      <el-table-column
        label="会员卡号"
        prop="card.card_num"
        align="center"
      ></el-table-column>
      <el-table-column label="会员名称" prop="user.real_name" align="center">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="rowClick(scope.row.card.id)">
              {{ scope.row.user.real_name }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号码" prop="user.mobile" align="center">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="rowClick(scope.row.card.id)">
              {{ scope.row.user.mobile }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="油品"
        prop="name"
        align="center"
      ></el-table-column>
      <el-table-column label="升数" prop="num" align="center"></el-table-column>
      <el-table-column
        label="应收金额"
        prop="money"
        align="center"
      ></el-table-column>
      <el-table-column
        label="下单时间"
        width="99px"
        prop="create_time"
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作员"
        prop="emp.name"
        align="center"
      ></el-table-column>
      <el-table-column
        label="来源"
        prop="show_from"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="98px">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="padding: 0;"
            v-if="
              scope.row.allow_pay == '1' && scope.row.payment_code == 'cash'
            "
            @click="confirmOrderItem(scope.row.ordersn, 1, 'cash')"
          >
            确认
          </el-button>
          <el-button
            type="text"
            style="padding: 0; color: #f56c6c;"
            v-if="
              scope.row.allow_pay == '1' && scope.row.payment_code == 'cash'
            "
            @click="confirmOrderItem(scope.row.ordersn, 2)"
          >
            取消
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;">
      <el-pagination
        layout="prev, pager, next, total"
        :current-page="cashPage"
        :total="cashTotal"
        :page-size="10"
        background
        @current-change="getdata_page"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="showConfirmOrder"
      @close="showConfirmOrder = false"
      title="确认支付"
      width="400px"
    >
      <div class="align_c" style="margin-top: -15px;">
        支付方式：
        <el-select
          size="small"
          v-model="confirmData.type"
          style="width: 180px; margin-right: 15px;"
        >
          <el-option
            v-for="item in handlePay"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="confirmOrderSubmit()"
        >
          确认
        </el-button>
      </div>
      <!-- <div class="align_c" style="margin-top:15px"><el-button size="small" type="primary" @click="confirmOrderSubmit()">确认</el-button></div> -->
    </el-dialog>
    <!-- 取消订单 -->
    <el-dialog
      :visible.sync="showCancelOrder"
      @close="showCancelOrder = false"
      title="取消订单"
      width="400px"
    >
      <div style="margin-bottom: 20px;">订单号：{{ confirmData.ordersn }}</div>
      <div>
        <el-button
          style="width: 100%;"
          type="danger"
          size="samll"
          :loading="submitLoading"
          @click="cancelOrderSubmit()"
        >
          取消订单
        </el-button>
      </div>
      <!-- <div class="align_c" style="margin-top:15px"><el-button size="small" type="primary" @click="confirmOrderSubmit()">确认</el-button></div> -->
    </el-dialog>
  </div>
</template>

<script>
import { cancelOrder, confirmOrder, vipOrderList } from '@/api/vip'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  data() {
    return {
      cashPage: 1,
      cashTotal: 0,
      cashConfirmData: [],
      confirmData: {}, // 确认未支付订单信息
      submitLoading: false, // 确认、取消订单loading
      from_options: [
        { id: 'wx', name: '微信' },
        { id: 'h5', name: '支付宝' },
        { id: 'wxapp', name: '微信小程序' },
        { id: 'aliapp', name: '支付宝小程序' },
        { id: 'pos', name: 'pos终端机' },
        { id: 'pc', name: '后台' },
        { id: 'hand', name: '手持终端' },
        { id: 'ruyi', name: '如意' },
        { id: 'ali', name: '支付宝' },
      ], //来源选择项
      mobile: '',
      cashLoading: false,
      handlePay: [{ label: '现金', value: 'cash' }],
      showConfirmOrder: false,
      showCancelOrder: false,
    }
  },
  mounted() {
    this.getdata()
  },
  methods: {
    getdata_page(val) {
      this.cashPage = val
      this.getdata()
    },
    async getdata() {
      this.cashLoading = true
      let data = {
        app_id: this.app_id,
        page: this.cashPage,
        pay_status: '1',
        payment_code: 'cash',
      }
      if (this.mobile !== '') {
        data.mobile = this.mobile
      }
      const res = await vipOrderList(data)
      this.cashLoading = false
      this.cashConfirmData = res.data
      this.cashTotal = res.total
      this.cashConfirmData.forEach((item) => {
        item.show_from = this.from_options.find((x) => x.id == item.source).name
      })
    },
    rowClick(id) {
      console.log('hang')
      this.$router.push({
        path: '/apply/newVip/13/center/userDetail',
        query: { id: id },
      })
    },
    // 确认未支付订单窗口
    confirmOrderItem(ordersn, type, pay_type) {
      if (pay_type == 'cash') {
        this.handlePay[0] = {
          label: '现金',
          value: 'cash',
        }
      }
      this.confirmData = {
        ordersn: ordersn,
        type: pay_type,
      }
      if (type == 1) {
        this.showConfirmOrder = true
      } else {
        this.showCancelOrder = true
      }
    },
    // 取消未支付订单
    cancelOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
      }
      this.submitLoading = true
      cancelOrder(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '取消成功',
          })
          this.showCancelOrder = false
          this.getdata()
        } else {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
        this.submitLoading = false
      })
    },
    // 确认未支付订单
    confirmOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
        payment_code: this.confirmData.type,
      }
      this.submitLoading = true
      confirmOrder(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '保存成功',
          })
          this.showConfirmOrder = false
          this.getdata()
        } else {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
        this.submitLoading = false
      })
    },
  },
  components: {},
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 26px 11px 20px;
  height: 100%;
  border: 1px solid #f1f1f1;
  overflow-y: auto;
  min-width: 900px;
  background: #ffffff;
}
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    height: 100%;
    padding: 22px 36px;
    .search_line {
      margin-bottom: 30px;
      .input_box {
        width: 224px;
        margin-right: 10px;
      }
    }
    .step_box {
    }
  }
}
</style>
<style>
::v-deep .rgt-con .rgt-con-2 {
  overflow-y: auto;
}
</style>
<style>
::v-deep .rgt-con .rgt-con-2 {
  overflow-y: auto;
}
</style>
